module.exports = "/static/assets/9a1be90552ed9ae76f6c4b963e9e3fa7.png";